var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "2.75vw",
    height: "2.5vh",
    viewBox: "0 0 1 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 8.50833C4 7.37667 4 6.81083 4.22833 6.31333C4.4575 5.81583 4.88667 5.44833 5.74583 4.71167L6.57917 3.9975C8.13333 2.66667 8.90833 2 9.83333 2C10.7583 2 11.5342 2.66583 13.0875 3.99667L13.9208 4.71083C14.7792 5.4475 15.2092 5.815 15.4375 6.3125C15.6667 6.81 15.6667 7.37583 15.6667 8.5075V12.0417C15.6667 13.6133 15.6667 14.3983 15.1783 14.8867C14.69 15.375 13.905 15.375 12.3333 15.375H7.33333C5.76167 15.375 4.97667 15.375 4.48833 14.8867C4 14.3983 4 13.6133 4 12.0417V8.50833Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9167 15.375V11.2083C11.9167 10.9873 11.8289 10.7754 11.6726 10.6191C11.5163 10.4628 11.3043 10.375 11.0833 10.375H8.58333C8.36232 10.375 8.15036 10.4628 7.99408 10.6191C7.8378 10.7754 7.75 10.9873 7.75 11.2083V15.375",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.47392bd0c0dc274ca691c012ff80aa70.svg";
export { ForwardRef as ReactComponent };